<template>
  <v-card>
    <v-card-title
      :style="`background: ${vocabulary.color}`" :class="`lighten-1 white--text subtitle-1 py-2 pr-12`">
      {{ vocabulary[userLanguages.base] }} ({{ vocabulary.vocabularies.length }})
      <Modal
        :headline="$t('myVocabulary.deleteMvContainer')"
        :has-text-field="false"
        :show-modal="showModal"
        :save-btn-name="$t('app.delete')"
        @save="deleteContainer"
        @cancel="showModal = false">
        <v-icon
          slot="activator"
          @click="showModal = true"
          right color="white" style="position: absolute; right: 15px;">
          delete
        </v-icon>
      </Modal>
    </v-card-title>
    <v-card-text>
      <v-row
        v-for="(word, index) in expand ? vocabulary.vocabularies : reducedWords"
        :key="`mvContainer-${index}`"
        dense>
        <v-col cols="6">
          <v-text-field
            :value="word[userLanguages.base]" dense class="caption" hide-details disabled />
        </v-col>
        <v-col cols="6">
          <v-text-field
            :value="word[userLanguages.learning]" dense class="caption" hide-details disabled />
        </v-col>
      </v-row>
      <v-row dense class="pt-1">
        <v-col v-if="hasVocabularies" class="text-center">
          <div
            v-if="vocabulary.vocabularies.length > 2"
            @click="expand = !expand"
            style="border-bottom: 1px solid lightgray;" class="pb-2">
            <v-icon left>
              {{ expand ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
            </v-icon>
            {{ expand ? $t('myVocabulary.showLess') : $t('myVocabulary.showMore') }}
          </div>
          <v-btn
            @click="showItemsModal = true"
            small block :ripple="false" color="green" dark class="mt-4">
            {{ $t('app.add') }}/ {{ $t('app.edit') }}
          </v-btn>
        </v-col>
        <v-col v-else class="text-center">
          <div>{{ $t('myVocabulary.topicNoVocabulary') }}.</div>
        </v-col>
      </v-row>
    </v-card-text>
    <MvItems
      :vocabulary-list="vocabularyList"
      :vocabulary-list-keys="vocabularyListKeys"
      :props-vocabulary="vocabulary"
      :show-modal="showItemsModal"
      @close:modal="showItemsModal = $event"
      @updated:vocabulary="$emit('updated:vocabulary')" />
  </v-card>
</template>

<script>
import Modal from '@components/modal';
import { mapGetters } from 'vuex';
import MvItems from './components/mv_items/MvItems';

export default {
  name: 'MvContainer',
  components: {
    Modal,
    MvItems,
  },
  data: () => ({
    showModal: false,
    showItemsModal: false,
    expand: false,
  }),
  props: {
    vocabulary: {
      type: Object,
      required: true,
    },
    vocabularyList: {
      type: Array,
      required: true,
    },
    vocabularyListKeys: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapGetters('user', ['userLanguages']),

    hasVocabularies() {
      return this.vocabulary.vocabularies.length > 0;
    },
    reducedWords() {
      return this.vocabulary.vocabularies.slice(0, 2);
    },
  },
  methods: {
    deleteContainer() {
      this.showModal = false;

      const topicIndex = this._.findIndex(this.vocabularyList, {
        [this.userLanguages.base]: this.vocabulary[this.userLanguages.base],
      });

      const vocabularyListKey = this.vocabularyListKeys[topicIndex];

      this.$emit('delete:mvContainer', vocabularyListKey);
    },
  },
};
</script>
